import {React, styled} from 'common'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {useI18n} from 'store/Store'
import {useFormContext} from 'react-hook-form'
import {Images} from 'appearance'
import WizardComponentWrapper from '../WizardComponentWrapper'
import {useDeviceDetect, useYupValidation} from 'services/hooks'
import {registerLoginDetailsSchema} from 'services/utils/validationsSchemas'
import analyticsService from 'services/analytic'

const LoginDetails = ({setValidationError}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    const formContext = useFormContext()
    const {
        control: formControl,
        formState: {errors: formErrors},
        getValues,
        watch,
    } = formContext

    const firstName = watch('firstName')
    const lastName = watch('lastName')
    const email = watch('email')
    const username = watch('username')

    useYupValidation(
        registerLoginDetailsSchema,
        getValues,
        [firstName, lastName, email, username],
        setValidationError
    )

    return (
        <WizardComponentWrapper sideImage={Images.REGISTER_STEP_1}>
            <InnerContent isMobile={isMobile}>
                <NameInputs>
                    <StyledFormTextInput
                        isMobile={isMobile}
                        name="firstName"
                        label={i18n.t('users.firstname')}
                        control={formControl}
                        fullWidth
                        type="text"
                        initialValue=""
                        errors={formErrors}
                        height="48px"
                        style={{color: '#95969A'}}
                        InputProps={{style: {background: '#FAFAFA'}}}
                    />
                    <StyledFormTextInput
                        isMobile={isMobile}
                        name="lastName"
                        label={i18n.t('users.lastname')}
                        control={formControl}
                        fullWidth
                        type="text"
                        initialValue=""
                        errors={formErrors}
                        height="48px"
                        style={{color: '#95969A'}}
                        InputProps={{style: {background: '#FAFAFA'}}}
                    />
                </NameInputs>

                <StyledFormTextInput
                    isMobile={isMobile}
                    name="email"
                    label={i18n.t('users.email')}
                    control={formControl}
                    fullWidth
                    type="text"
                    initialValue=""
                    errors={formErrors}
                    height="48px"
                    style={{color: '#95969A'}}
                    InputProps={{style: {background: '#FAFAFA'}}}
                />

                <StyledFormTextInput
                    isMobile={isMobile}
                    name="username"
                    label={i18n.t('users.phone')}
                    control={formControl}
                    fullWidth
                    type="text"
                    initialValue=""
                    errors={formErrors}
                    height="48px"
                    style={{color: '#95969A'}}
                    InputProps={{style: {background: '#FAFAFA'}}}
                />

                <StyledFormTextInput
                    isMobile={isMobile}
                    optional
                    name="PlannerSubscriptions"
                    label={i18n.t('users.orgCode')}
                    placeholder={i18n.t('users.orgCodePlaceholder')}
                    control={formControl}
                    fullWidth
                    onBlur={() => {
                        if (getValues('PlannerSubscriptions')) {
                            analyticsService.onboardingFillOrganizationCode()
                        }
                    }}
                    type="text"
                    initialValue=""
                    errors={formErrors}
                    height="48px"
                    style={{color: '#95969A'}}
                    InputProps={{style: {background: '#FAFAFA'}}}
                />
            </InnerContent>
        </WizardComponentWrapper>
    )
}

export default LoginDetails

const InnerContent = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: ${({isMobile}) =>
        isMobile ? 'flex-start' : 'space-between'};
    flex: 1;
    width: 100%;
`

const NameInputs = styled('div')`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
`

const StyledFormTextInput = styled(FormTextInput)`
    margin-bottom: ${({isMobile}) => (isMobile ? 20 : 0)}px;
`
